<template>
  <CovertPage
    v-if="isRender" v-reportView:load="{ pageload: 1, pagetype: 2 }" :cmd="cmd" :fileType="fileType"
    :toFileType="toFileType" :customOptionType="customOptionType" :covertTitle="covertTitle" :targetTypes="targetTypes" />
</template>

<script>
import CovertPage from '@/components/common/CovertPage'

import { FILE_TYPE, NAV_LIST } from '@/config/config'
import { capitalizeFirstLetter } from '@/utils/shared'

export default {
  components: {
    CovertPage
  },

  data () {
    return {
      isRender: true,

      cmd: '',
      fileType: FILE_TYPE.NONE,
      toFileType: FILE_TYPE.NONE,
      targetTypes: [],
      covertTitle: '',
      customOptionType: undefined
    }
  },

  beforeMount () {
    this.$EventBus.$on('routeChange', this.listenRouteChange)
  },

  beforeDestroy () {
    this.$EventBus.$off('routeChange', this.listenRouteChange)
  },

  methods: {
    listenRouteChange ({ to }) {
      /**
      * 获取config/config[NAV_LIST]配置的title
      */
      const getCovertTitle = (routeName) => {
        if (!routeName) return ''

        for (let i = 0, len = NAV_LIST.length; i < len; i++) {
          const navItem = NAV_LIST[i]
          const navItemChildren = navItem.children
          for (let j = 0, lenJ = navItemChildren.length; j < lenJ; j++) {
            const item = navItemChildren[j]
            const _routeName = item.routeName
            if (_routeName === routeName) {
              return item.coverTitle
            }
          }
        }
        return ''
      }

      this.covertTitle = getCovertTitle(to.name)
      this.getCurrentRouteInfo()

      this.isRender = false // 路由变化，直接干掉所有现在的流程
      this.$nextTick(() => {
        this.isRender = true
      })
    },

    getCurrentRouteInfo () {
      const { meta = {}, query = {} } = this.$route
      const { groupDefault = {} } = meta

      const { group_name: groupName } = query

      let groupConfig = groupDefault

      if (groupName) {
        const _groupConfig = meta[`group${capitalizeFirstLetter(groupName)}`]
        if (_groupConfig) {
          groupConfig = _groupConfig
        }
      }

      const { cmd, fileType, toFileType, targetTypes, customOptionType } = groupConfig

      this.cmd = cmd
      this.fileType = fileType
      this.toFileType = toFileType
      this.targetTypes = targetTypes
      this.customOptionType = customOptionType
    }
  }
}
</script>
